keysByJSON